<template>
  <Breadcrumbs
    title="Distributor Wise Dealer Stock Report"
    :breadcrumbs="[
      { label: 'Sales', path: '' },
      { label: 'Invoices', path: '/invoice' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <DistributorWiseDealerStockForm />
    </div>
  </div>
</template>

<script>
import DistributorWiseDealerStockForm from './distributorwisedealerstock_form.vue';

export default {
  name: 'DistributorWiseDealerStockReport',
  components: {
    DistributorWiseDealerStockForm,
  },
};
</script>

